import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import {
  InViewTracking,
  useInsightsTracking,
} from '@xing-com/crate-insights-tracking';
import { IconButterflyMono } from '@xing-com/icons';
import { IllustrationEmptyStateRadar } from '@xing-com/illustrations';
import { Meta } from '@xing-com/typography';

import { Styled } from './registration-card.styled';

export const RegistrationCard = ({
  positionInModule,
}: {
  positionInModule?: number;
}): JSX.Element => {
  const { trackWithNWT } = useInsightsTracking();
  const trackData = {
    element: 'sign_up',
    element_detail: 'insights_job_search_articles',
    moduleTitle: 'discover_insights_job_search_articles',
    position: 23,
    verticalPosition: 4,
    modulePosition: 4,
    positionInModule,
  };
  const track = (): void => trackWithNWT({ event: 'opened', ...trackData });

  return (
    <InViewTracking nwtTrackingOptions={trackData}>
      <Styled.Card>
        <Styled.Content>
          <IllustrationEmptyStateRadar size="large" />
          <Meta>
            <FormattedMessage id="INSIGHTS_LO_SIGNUP_CARD_DESCRIPTION" />
          </Meta>
          <Button
            icon={IconButterflyMono}
            size="medium"
            variant="primary"
            onClick={track}
            to="/start/signup?sc_o=insights_sign_up_click&sc_o_PropActionOrigin=discover_update_InsightsJobSearchArticlesModule&signup_channel=minireg_insights"
          >
            <FormattedMessage id="INSIGHTS_LO_SIGNUP_CARD_CTA" />
          </Button>
        </Styled.Content>
      </Styled.Card>
    </InViewTracking>
  );
};
